import { createComponent } from '../core/create-component.js';
const ModalDialogHeader = createComponent({
  displayName: 'ModalDialogHeader',
  root: 'div',
  propConfig: {
    classNames: ['swan-modal-dialog-header']
  }
}) // TODO: Write test cases for ModalDialog
;

export { ModalDialogHeader };